import React, { forwardRef, useImperativeHandle } from 'react';
import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';

import Application from '../pdf/transcript_AEG.pdf';
import TimesOfroman from '../fonts/Times-Roman.ttf';
import TimesNewRomanBold from '../fonts/TimesNewRomanBold.ttf';

import { removeBracketedText } from '../Axiosinstance';

const ApplicationForm = forwardRef((dataProp, ref) => {

    // const formatDateRange = (scheduleDate) => {
    //     if (!Array.isArray(scheduleDate) || scheduleDate.length === 0) return '';
    //     const monthNames = [
    //         'January', 'February', 'March', 'April', 'May', 'June',
    //         'July', 'August', 'September', 'October', 'November', 'December'
    //     ];
    //     const formatDate = (dateStr) => {
    //         const date = new Date(dateStr);
    //         const day = String(date.getDate()).padStart(2, '0');
    //         const month = monthNames[date.getMonth()];
    //         const year = date.getFullYear();
    //         return `${day} ${month} ${year}`;
    //     };
    //     const start = formatDate(scheduleDate[0].startDate);
    //     const end = formatDate(scheduleDate[scheduleDate.length - 1].endDate);
    //     return `${start}  -  ${end}`;
    // };

const formatDateRange = (scheduleDate) => {
    if (!Array.isArray(scheduleDate) || scheduleDate.length === 0) return '';

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const formatDate = (dateObj) => {
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = monthNames[dateObj.getMonth()];
        const year = dateObj.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Start date: take first element's startDate
    const startDate = new Date(scheduleDate[0].startDate);
    const start = formatDate(startDate);

    // Calculate End Date based on startDate:
    const oneYearLater = new Date(startDate);
    oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
    const finalEndDate = new Date(oneYearLater.getTime() - (24 * 60 * 60 * 1000)); // subtract 1 day

    const end = formatDate(finalEndDate);

    return `${start}  -  ${end}`;
};


    function formatDateToLongUK(dateString) {
        if (!dateString) return 'not available';

        const date = new Date(dateString);

        if (isNaN(date)) return 'invalid date';

        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        }).format(date);
    }


    const getGrade = (marks) => {
        if (marks >= 90) return 'A';
        if (marks >= 76) return 'B';
        if (marks >= 60) return 'C';
        if (marks >= 50) return 'D';
        return 'F';
    };

    const formatDurationType = (type) => {
    if (!type) return 'Not Available';
    return type
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('-');
};

    const handleDownload = async (studentdetails) => {
        try {
            const pdfBytes = await fetch(Application).then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);
            const fontSize = 12;
            // Register fontkit for custom font support
            pdfDoc.registerFontkit(fontkit);

            // Load and embed custom font
            const fontData = await fetch(TimesOfroman).then(res => res.arrayBuffer());
            const customFont = await pdfDoc.embedFont(fontData);

            const boldFontData = await fetch(TimesNewRomanBold).then(res => res.arrayBuffer());
            const boldFont = await pdfDoc.embedFont(boldFontData);

            const pages = pdfDoc.getPages();
            const firstPage = pages[0];

            const studentName = (studentdetails?.name || '').toUpperCase();
            const studentID = (studentdetails?.customId || '');

            const nric = studentdetails?.nric || 'not avaiable';
            const durationType = formatDurationType(studentdetails?.durationType);
            const scheduleDate = studentdetails?.scheduleDate || [];
            console.log("scheduleDate:",scheduleDate)
            const dateOfIssue = formatDateToLongUK(studentdetails?.transcriptIssueDate) || 'not avaiable';
            const TranscriptNo = studentdetails?.transcriptNumber || '';
            const markSheets = studentdetails?.markSheets || [];
            const course = removeBracketedText((studentdetails?.course || '')).toUpperCase();

            firstPage.drawText(studentName, { x: 185, y: 684, size: fontSize, font: customFont, color: rgb(0, 0, 0) });
            firstPage.drawText(studentID, { x: 185, y: 655, size: fontSize, font: customFont, color: rgb(0, 0, 0) });
            firstPage.drawText(nric, { x: 185, y: 627, size: fontSize, font: customFont, color: rgb(0, 0, 0) });
            firstPage.drawText(durationType, { x: 185, y: 598, size: fontSize, font: customFont, color: rgb(0, 0, 0) });
            const pageWidth = firstPage.getWidth();

            const textWidth = boldFont.widthOfTextAtSize(course, fontSize);
            const xCentered = (pageWidth - textWidth) / 2;
            const yPosition = 720;

            // Draw the text
            firstPage.drawText(course, {
                x: xCentered,
                y: yPosition,
                size: fontSize,
                font: boldFont,
                color: rgb(0, 0, 0)
            });

            // Draw the underline
            const underlineY = yPosition - 2; // adjust distance below text
            firstPage.drawLine({
                start: { x: xCentered, y: underlineY },
                end: { x: xCentered + textWidth, y: underlineY },
                thickness: 0.75,
                color: rgb(0, 0, 0),
            });


            firstPage.drawText(formatDateRange(scheduleDate), {
                x: 185,
                y: 570,
                size: fontSize,
                font: customFont,
                color: rgb(0, 0, 0)
            });

            firstPage.drawText(dateOfIssue, { x: 185, y: 542, size: fontSize, font: customFont, color: rgb(0, 0, 0) });
            firstPage.drawText(TranscriptNo, { x: 185, y: 515, size: fontSize, font: customFont, color: rgb(0, 0, 0) });

            const tableStartY = 427;
            const rowHeight = 24.5;

            const tableFontSize = 12;
            const col1X = 50;
            const col2X = 120;
            const col3X = 479;

            markSheets.forEach((sheet, index) => {
                const y = tableStartY - index * rowHeight;

                // Module Name
                firstPage.drawText(sheet.moduleNameCode.toUpperCase(), {
                    x: col1X,
                    y,
                    size: tableFontSize,
                    font: customFont,
                    color: rgb(0, 0, 0),
                });

                // Module Code
                firstPage.drawText(sheet.module.trim(), {
                    x: col2X,
                    y,
                    size: tableFontSize,
                    font: customFont,
                    color: rgb(0, 0, 0),
                });

                // Mark
                firstPage.drawText(getGrade(String(sheet.mark)), {
                    x: col3X,
                    y,
                    size: tableFontSize,
                    font: customFont,
                    color: rgb(0, 0, 0),
                });
            });




            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    useImperativeHandle(ref, () => ({ handleDownload }));

    return null;
});

export default ApplicationForm;
